import Autoload from "../../Autoload";

class GlobalServices {

    _getCostTypeByProperty(functionCallingContext, responseFunctionName, props, cbData = null) {
        console.log('_getCostTypeByProperty: ', cbData);
        props.id !== undefined && 
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url + "costTypes?propertyId=" + props.id + "&offset=0&fetch=100",
            "GET",
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName,
            cbData, false, "",
            {
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getHeatingCostTypesByProperty(functionCallingContext, responseFunctionName, props, cbData = null) {
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.ub_api_base_url + 'heatingCostSystemTypes?propertyId=' + props.id,
            'GET',
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName,
            cbData, false, "",
            {
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getAllocationKeysByProperty(functionCallingContext, responseFunctionName, props, others) {
        console.log('_getAllocationKeysByProperty: ', others);
        props.id !== undefined && 
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url+"AllocationKeys?propertyId="+props.id+"&offset=0&fetch=100",
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName,
            others ? others : null, false, "",
            {
                'Content-Type': 'application/json',
                Authorization: Autoload.Utils.getAuthToken()
            }
        );
    }

    _getReceiptsByProperty(functionCallingContext, responseFunctionName, props) {
        Autoload.HttpRequestAxios.HttpRequest(
            // Autoload.Setting.rm_api_base_url+"receipts?propertyId="+props.id,
            Autoload.Setting.rm_api_base_url+"property/"+props.id+`${props.includeDetails !== undefined ? "?includeDetails="+props.includeDetails : ""}${props.offset !== undefined ? (props.includeDetails !== undefined ? "&" : "?")+"offset="+props.offset : ""}${props.fetch !== undefined ? (props.includeDetails !== undefined || props.offset !== undefined ? "&" : "?")+"fetch="+props.fetch : ""}`,
            // Autoload.Setting.api_base_url+"receipt-api/receipt?propertyId="+props.id,
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            null, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getReceiptsByPropertyWithoutDetails(functionCallingContext, responseFunctionName, props) {
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.rm_api_base_url+"property/"+props.id+"?includeDetails=false",
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            null, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getReceiptsByPropertyWithFilters(functionCallingContext, responseFunctionName, props, cbData = null) {
        let payload = {
            propertyId: props?.propertyId,
            keyword: props?.keyword,
            receiptPeriodStart: props?.receiptPeriodStart,
            receiptPeriodEnd: props?.receiptPeriodEnd,
            taxCostTypes: props?.taxCostTypes,
            receiptDateFrom: props?.receiptDateFrom,
            receiptDateTo: props?.receiptDateTo,
            costsMin: props?.costsMin,
            costsMax: props?.costsMax,
            utilityBillingRelevant: props?.utilityBillingRelevant,
            isValidated: props?.isValidated,
            utilityBillingAllocated: props?.utilityBillingAllocated,
            selectedCostTypeId: props?.selectedCostTypeId,
            includeDetails: props?.includeDetails,
            offset: props?.offset,
            fetch: props?.fetch,
            heatingCostType: props?.heatingCostType,
            sortBy: props?.sortBy,
            descending: props?.descending
        };

        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.rm_api_base_url+"search",
            "POST", 
            payload, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            cbData, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getReceiptsByBillingPeriod(functionCallingContext, responseFunctionName, props) {
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.rm_api_base_url+"getAllBy?billingPeriodId="+props.billingPeriodId,
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            null, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getRentalUnitsByProperty(functionCallingContext, responseFunctionName, props) {
        props.id !== undefined &&
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url+"rentalUnits?propertyId="+props.id+"&offset=0&fetch=100",
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            null, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getTenantsByRentalUnitID(functionCallingContext, responseFunctionName, props) {
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url+"tenants?rentalUnitId="+props.rentalUnit.id+"&offset=0&fetch=100",
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            props, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getRentsByTenantId(functionCallingContext, responseFunctionName, props){
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url + 'rents?offset=0&fetch=100&tenantId=' + props.tenant.id,
            'GET',
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName,
            props,
            false, "",
            {
              'Content-Type': 'application/json',
              Authorization: Autoload.Utils.getAuthToken()
            }
        );
    }

    _getBilingPeriodsByProperty(functionCallingContext, responseFunctionName, props, url_part ="BillingPeriods?propertyId=" ) {
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url+url_part+props.id+"&offset=0&fetch=100",
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            null, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getUtilityBillingsByProperty(functionCallingContext, responseFunctionName, props, url_part ="utilityBillings?propertyId=" ) {
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.ub_api_base_url+url_part+props.id,
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            null, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getPropertiesByAccountId(functionCallingContext, responseFunctionName, props) {
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url + 'properties?accountId=' + props.accountId + '&offset=0&fetch=100',
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            null, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    _getSystemHeatingCostTypes=(functionCallingContext, responseFunctionName, props)=>{
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.ub_api_base_url + 'heatingCostSystemTypes?propertyId='+props.propertyId,
            'GET',
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            null, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }
}


export default new GlobalServices();